import React, { useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import { useQuery } from "react-query";
import CustomTable from "../common/Table";
import { disableFutureDates, formatDate } from "../../services/util";
import { Card, DatePicker, Skeleton } from "antd";
import moment from "moment";
const { RangePicker } = DatePicker;

const columns = [
    {
        title: "Key",
        key: "ticket_key",
        render: (text, record) => {
            return (
                <a href={record.link} target="_blank" rel="noreferrer">
                    {record.ticket_key}
                </a>
            );
        },
    },

    {
        title: "Hotel",
        dataIndex: "hotel_name",
        key: "hotel_name",
        sorter: () => {},
        width: 200,
    },
    {
        title: "Component",
        dataIndex: "component_name",
        key: "component_name",
        sorter: () => {},
        width: 150,
    },
    {
        title: "Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: () => {},
        width: 150,
    },
    {
        title: "Summary",
        dataIndex: "summary",
        key: "summary",
        sorter: () => {},
        width: 200,
    },
    {
        title: "Type",
        dataIndex: "issue_type",
        key: "issue_type",
        sorter: () => {},
        width: 150,
    },
    {
        title: "Priority",
        dataIndex: "priority",
        key: "priority",
        sorter: () => {},
    },
    {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: () => {},
        width: 150,
    },
    {
        title: "Reported By",
        dataIndex: "reporter_name",
        key: "reporter_name",
        sorter: () => {},
        width: 150,
    },
    {
        title: "Assigned To",
        dataIndex: "assignee_name",
        key: "assignee_name",
        sorter: () => {},
    },
];
const SupportTicketTable = ({
    component_name = "",
    hotel_ids = [],
    start_date,
    end_date,
}) => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [selectedDates, setSelectedDates] = useState([
        moment(start_date),
        moment(end_date),
    ]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        start_date: formatDate(selectedDates[0]),
        end_date: formatDate(selectedDates[1]),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        need_status_filter: true,
        all_selected: hotel_ids.length > 0 ? false : true,
        component_name: component_name,
    });

    const {
        status: supportDetailStatus,
        data: supportDetailsRes,
        refetch: fetchSupportDetails,
    } = useQuery(
        `supportDetails_${hotel_ids}${component_name}`,
        async () => {
            return await HTTP("/dashboard/getSupportJiraTickets", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchSupportDetails();
    }, [formData]);

    useEffect(() => {
        if (supportDetailStatus === "success") {
            const { data: scanData, total } = supportDetailsRes;
            setTotalRecords(total);
            setTableData(scanData);
        }
    }, [supportDetailStatus, supportDetailsRes]);

    function handleDateChange(e) {
        console.log(`date change event triggerd`, e);
        let start_date =
            e !== null ? moment(e[0]).startOf("day") : selectedDates[0];
        let end_date =
            e !== null ? moment(e[1]).startOf("day") : selectedDates[1];

        // set the default value if null
        setSelectedDates([start_date, end_date]);
        start_date = formatDate(start_date);
        end_date = formatDate(end_date);
        setFormData({ ...formData, start_date, end_date });
    }

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <RangePicker
                allowClear={false}
                disabledDate={disableFutureDates}
                defaultValue={[
                    moment(selectedDates[0]),
                    moment(selectedDates[1]),
                ]}
                value={[moment(selectedDates[0]), moment(selectedDates[1])]}
                className="dashboard-date-search margin-right-5 select-container"
                onChange={handleDateChange}
                format="MM/DD/YYYY"
                ranges={{
                    Today: [moment(), moment()],
                    Yesterday: [
                        moment().subtract(1, "day"),
                        moment().subtract(1, "day"),
                    ],
                    "Last 7 Days": [moment().subtract(7, "day"), moment()],
                    "Last 30 Days": [moment().subtract(29, "day"), moment()],
                    "Current Month": [moment().startOf("month"), moment()],
                    "Last Month": [
                        moment().subtract(1, "month").startOf("month"),
                        moment().subtract(1, "month").endOf("month"),
                    ],
                    "Last 3 Month": [moment().subtract(3, "month"), moment()],
                }}
                style={{ margin: "15px", marginLeft: "auto" }}
            />
            {supportDetailStatus === "loading" ||
            supportDetailStatus === "idle" ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 25, width: "100vw" }}
                />
            ) : (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="ticket_key"
                    className="support-table"
                    pagination={{
                        hideOnSinglePage: false,
                        responsive: true,
                        total: totalRecords,
                        defaultPageSize: formData.limit,
                        defaultCurrent: formData.page + 1 || 0,
                        showSizeChanger: true,
                        pageSizeOptions: [10, 20, 50],
                        showTotal: (totalRecords, range) =>
                            `${range[0]}-${range[1]} of ${totalRecords} records`,
                        current: formData?.page + 1 || 0,
                    }}
                    isScroll
                />
            )}
        </div>
    );
};

export { SupportTicketTable };
